module.exports = __webpack_public_path__ + "img/close.9b2a5a59.svg";